const contactData = {
 
   infoTitle: "Contact Information",

  infoCards: [
    {
      icon: "fas fa-map-marker-alt",
      title: "Visit Us",
      text: "123 Spice Street, Food District, Mumbai, Maharashtra 400001",
    },
    {
      icon: "fas fa-phone",
      title: "Call Us",
      text: "+91 98765 43210, +91 98765 43211",
    },
    {
      icon: "fas fa-envelope",
      title: "Email Us",
      text: "info@spicegarden.com, reservations@spicegarden.com",
    },
    {
      icon: "fas fa-clock",
      title: "Opening Hours",
      text: "Mon–Thu: 11AM - 10PM | Fri–Sun: 11AM - 11PM",
    },
  ],

  map: {
    title: "Find Us on Map",
    url:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.9876543210!2d72.8776559!3d19.0759837",
  },

  faqs: [
    {
      q: "Do you take reservations?",
      a: "Yes, we highly recommend reservations, especially on weekends.",
    },
    {
      q: "Do you offer vegetarian and vegan options?",
      a: "Yes, we have extensive vegetarian and vegan-friendly options.",
    },
    {
      q: "Do you provide catering services?",
      a: "Yes, we cater weddings, corporate events, and private parties.",
    },
    {
      q: "Is parking available?",
      a: "Yes, complimentary parking is available for our guests.",
    },
    {
      q: "Do you offer home delivery?",
      a: "Yes, we deliver within a 5km radius.",
    },
  ],
};

export default contactData;
